import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CompanyIndexResponse } from '@/repositories/generated';

const content: CompanyIndexResponse[] = [
  {
    name: 'テスト企業００１',
    externalCompanyId: 'hogecompany1',
    id: '123',
    status: 'AVAILABLE',
    acquirerName: 'アクワイアラ０１０',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2022-12-28',
    isSmartCode: false,
  },
  {
    name: 'テスト企業００２',
    externalCompanyId: 'hogecompany2',
    id: '555',
    status: 'WAITING',
    acquirerName: 'アクワイアラ０１１',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2022-12-28',
    isSmartCode: false,
  },
  {
    name: 'テスト企業００３',
    externalCompanyId: 'hogecompany3',
    id: 'company01',
    status: 'CLOSED',
    acquirerName: 'アクワイアラ０１２',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2022-12-28',
    isSmartCode: false,
  },
  {
    name: 'テスト企業００４',
    externalCompanyId: 'hogecompany4',
    id: 'company04',
    status: 'SMART_CODE_AVAILABLE',
    acquirerName: 'アクワイアラ０１２',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2022-12-28',
    isSmartCode: true,
  },
  {
    name: 'テスト企業００５',
    externalCompanyId: 'hogecompany5',
    id: 'company05',
    status: 'SMART_CODE_WAITING',
    acquirerName: 'アクワイアラ０１２',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2022-12-28',
    isSmartCode: true,
  },
  {
    name: 'テスト企業００６',
    externalCompanyId: 'hogecompany6',
    id: 'company06',
    acquirerName: 'アクワイアラ０１２',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2022-12-28',
    isSmartCode: true,
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const company = http.get(
  createMockEndpoint('/company'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const companyExists = url.searchParams.get('name') ?? '';
    const idExists = url.searchParams.get('id') ?? '';
    const acquirerIdExists = url.searchParams.get('acquirerId') ?? '';

    if (companyExists || idExists || acquirerIdExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
